function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
// ----------------------------------------------------------------------------
// Product Form Web Component: iamBuyNowButton <iam-buy-now-button>
// Extends: iamFormElement
// ----------------------------------------------------------------------------
// Manage the state and behavior of the "Buy Now" button in response to
// product form interactions.
// - Dynamically updates the button's text and loading states during the
//   add-to-cart and checkout process.
// ----------------------------------------------------------------------------
// Event Listeners:
// - `productForm:submitting`         → Updates the button state to "Adding to Cart"
//                                      while the request is being processed
// - `productForm:submitted:success`  → Temporarily updates the button state to
//                                      "Added to Cart" before redirecting to checkout
// - `productForm:submitted:error`    → Updates the button state to an "Error" state
//                                      if the add-to-cart request fails
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import iamFormElement from 'scripts/classes/iamFormElement';

// -------------------------------------
// Web Component
// -------------------------------------

class iamBuyNowButton extends iamFormElement {
  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    // Bind event listeners - only listen when it's the checkout button
    iamotaEventHandler.subscribe('productForm:submitting', this.onAdding.bind(this), {
      context: this.iamForm,
      source: "buy-now-button.js"
    });
    iamotaEventHandler.subscribe('productForm:submitted:success', this.onAddSuccess.bind(this), {
      context: this.iamForm,
      source: "buy-now-button.js"
    });
    iamotaEventHandler.subscribe('productForm:submitted:error', this.onAddError.bind(this), {
      context: this.iamForm,
      source: "buy-now-button.js"
    });

    // State
    this.state = iamBuyNowButton.BUTTON_STATES.AVAILABLE;
    this.originalText = this.control.innerHTML;
  }

  /**
   * Handle form submission
   */
  onAdding(_ref) {
    var isCheckoutButton = _ref.isCheckoutButton;
    // Only update if it's the checkout button being clicked
    if (!isCheckoutButton) return;
    this.setState(iamBuyNowButton.BUTTON_STATES.ADDING);
  }
  onAddSuccess(_ref2) {
    var isCheckoutButton = _ref2.isCheckoutButton;
    // Only update if it's the checkout button being clicked
    if (!isCheckoutButton) return;
    this.setState(iamBuyNowButton.BUTTON_STATES.ADDED);
  }
  onAddError(_ref3) {
    var error = _ref3.error,
      isCheckoutButton = _ref3.isCheckoutButton;
    // Only update if it's the checkout button being clicked
    if (!isCheckoutButton) return;
    this.setState(iamBuyNowButton.BUTTON_STATES.ERROR);
  }

  /**
   * Set the current state and update the UI accordingly
   */
  setState(newState) {
    this.state = newState;
    switch (this.state) {
      case iamBuyNowButton.BUTTON_STATES.AVAILABLE:
        this.updateButton({
          buttonText: this.originalText,
          isDisabled: false,
          isLoading: false
        });
        break;
      case iamBuyNowButton.BUTTON_STATES.ADDING:
        this.updateButton({
          buttonText: translate('Adding to cart...', 'buyNow.adding', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true,
          isLoading: true
        });
        break;
      case iamBuyNowButton.BUTTON_STATES.ADDED:
        this.updateButton({
          buttonText: translate('Item added', 'buyNow.added', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true,
          isLoading: false
        });
        break;
      case iamBuyNowButton.BUTTON_STATES.ERROR:
        this.updateButton({
          buttonText: translate('Unable to add', 'buyNow.error', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true,
          isLoading: false
        });
        break;
      default:
        console.warn("Unknown buy-now-button state: ".concat(this.state));
        this.setState(iamBuyNowButton.BUTTON_STATES.ERROR);
        break;
    }
  }

  /**
   * Update button UI based on the provided options
   */
  updateButton(_ref4) {
    var _ref4$buttonText = _ref4.buttonText,
      buttonText = _ref4$buttonText === void 0 ? this.control.innerHTML : _ref4$buttonText,
      _ref4$isDisabled = _ref4.isDisabled,
      isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled,
      _ref4$isLoading = _ref4.isLoading,
      isLoading = _ref4$isLoading === void 0 ? false : _ref4$isLoading;
    this.setText(buttonText);
    this.setLoading(isLoading);
    this.setDisabled(isDisabled);
  }

  /**
   * Set the button text
   * @param {string} buttonText
  */
  setText(buttonText) {
    var _this = this;
    return _asyncToGenerator(function* () {
      buttonText = yield iamotaEventHandler.applyFilters('productForm:buyNowButton:buttonText', buttonText, {
        context: _this.iamForm
      });
      _this.control.innerHTML = buttonText;
      _this.control.setAttribute('aria-label', buttonText);
    })();
  }
}
_defineProperty(iamBuyNowButton, "BUTTON_STATES", {
  AVAILABLE: 'available',
  ADDING: 'adding',
  ADDED: 'added',
  ERROR: 'error'
});
customElements.define('iam-buy-now-button', iamBuyNowButton);